import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter
    ? `, filter: ${convertFilterRequestUrl(filter, [
      'type',
      'invoiceType',
      'invoiceDelivery',
      'status',
      'total',
      'due',
    ])}`
    : '';
  const searchInvoiceUnits = `searchInvoiceUnits(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchInvoiceUnits} {
        id
        accountId
        type
        invoiceType
        invoiceDate
        dueDate
        total
        due
        status
      }
    }
  `;
};
